import React from 'react';

import { SidePage } from '@gogame/components';

import { useAttachments } from 'scenes/Gallery/GalleryPage/Concepts/data';
import Attachments from 'scenes/Gallery/components/Attachments';
import { TAB_ATTACHMENTS } from 'scenes/Gallery/GalleryPage/constants';

const AttachmentTab = ({ conceptId }) => {
  const { data, isLoading, isRefetching } = useAttachments({ id: conceptId });

  return (
    <SidePage.Tab label={TAB_ATTACHMENTS} count={data?.length || '0'}>
      <SidePage.NewBody>
        <Attachments
          data={data}
          isLoading={isLoading}
          isRefetching={isRefetching}
        />
      </SidePage.NewBody>
    </SidePage.Tab>
  );
};

export default AttachmentTab;
